import { AlertContainerProps } from 'components/Alert/Alert.types';
import styled from 'styled-components';

export const AlertContainer = styled.div<AlertContainerProps>`
  min-height: 48px;
  display: ${(props) => (props.isVisible ? 'flex' : 'none')};
  align-items: center;
  gap: 12px;
  padding: 4px 8px 4px 16px;

  background: ${({ theme, sentiment }) => {
    if (sentiment === 'info') return theme.system.subtle.information;
    if (sentiment === 'warning') return theme.system.subtle.warning;
    if (sentiment === 'success') return theme.system.subtle.positive;
    if (sentiment === 'error') return theme.system.subtle.negative;
    return theme.system.subtle.negative;
  }};
`;
